<template>
    <el-dialog title="素材图片" :visible.sync="dialogVisible" width="770px" v-if="dialogVisible">
    <div class="warp">
        <div class="image">
            <div class="left_menu_box">
                <!-- <div class="top_box" :class="leftMenuIsSelect == -1 ? 'is_select' : 'no_select'" @click="leftMenuClick(-1)">全部图片</div> -->
                <div class="img_list" v-for="(item, index) of imgCollection" :key="index" :class="leftMenuIsSelect == index ? 'is_select' : 'no_select'" @click="leftMenuClick(index, item.catalogid)">
                    <div>
                        <div>
                            <span class="el-dropdown-link">
                                {{item.catename}}
                            </span>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right_main_box">
                <div class="img_content_list">
                    <div class="no_content" v-show="imgListData.length == 0">
                        <span>
                            暂无内容
                        </span>
                    </div>
                    <div class="img_content_box" v-show="imgListData.length !== 0">
                        <div class="select_box">
                            <div>
                                <el-checkbox v-model="isAllChecked" @change="checkAll">全选</el-checkbox>
                                <span>{{selectRecords}}条</span>
                            </div>
                        </div>
                        <div class="imgs_box"  v-viewer="{loading: true,title: true,loop: true,toolbar:true,navbar:false,title:false, transition: false}">
                            <div class="img_item" v-for="(item,index) of imgListData" :key="index">
                                <div>
                                    <img  v-lazy="item.csfileurl" alt="">
                                    <p @click="selectImg(index)" :class="item.aboolean ? 'show' : 'normal'"></p>
                                </div>
                                <div :title="item.name">
                                    {{item.name}}
                                </div>
                            </div>
                        </div>
                        <div class="page">
                            <el-pagination
                                background
                                @current-change="handleSizeChange"
                                :current-page.sync="pageParams.page"
                                :page-size="pageParams.pageSize"
                                :pager-count="11"
                                layout="prev, pager, next"
                                :total="total">
                            </el-pagination>
                        </div>
                        <div slot="footer" class="dialog-footer"  style="margin-top: 20px;">
                            <el-button @click="cancel">取 消</el-button>
                            <el-button type="primary" @click="sureAdd()">确 定</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </el-dialog>
</template>

<script>
import {getColList, findAllImage, findGroupImage} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'AllOrder',
    data() {
        return {
            dialogVisible: false,
            total: 0,
            pageParams: {
                page: 1,
                pageSize: 8
            },
            leftMenuIsSelect: 0, // 当前选中左侧菜单
            imgCollection: [], // 左侧图片合集菜单
            params: {
                name: '', // 图片合集名称
                type: 2
            },
            catalogInnerId: '', // 素材分类的innerid
            imgListData: [], // 右侧图片列表
            isAllChecked: false, // 是否全选
            selectRecords: 0, // 选择条数
            groupId: '' // 分类ID
        }
    },
    mounted() {
    },
    methods: {
        cancel() {
            this.dialogVisible = false
        },
        sureAdd() {
            let list = []
            this.imgListData.forEach(obj => {
                if (obj.aboolean) {
                    list.push(obj)
                }
            })
            this.$emit('setImage', list)
            this.cancel()
        },
        openDialog() {
            this.dialogVisible = true
            // this.getColListData()
            this.getAllImage()
        },
        // 分页
        handleSizeChange(val) {
            this.pageParams.page = val
            var params = {
                catalogInnerId: this.groupId
            }
            this.setLoading(true)
            findAllImage({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.imgListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    if (data.pageableData !== undefined) {
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 点击选中左侧菜单 添加背景色
        leftMenuClick(value, id) {
            this.leftMenuIsSelect = value
            this.isAllChecked = false
            this.groupId = id
            this.pageParams.page = 1
            console.log(value, id)
            if (value === -1) {
                this.groupId = ''
                this.getAllImage()
                return
            }
            if (value === -2) {
                this.groupId = ''
                this.params.name = '' // 重置新增合集名称
                this.addImgCollection = true
                return
            }
            this.getGroupImgs(this.groupId)
        },
        getGroupImgs(value) {
            this.setLoading(true)
            var params = {
                catalogInnerId: value
            }
            findGroupImage({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.imgListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    if (data.pageableData !== undefined) {
                    }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 全选
        checkAll() {
            if (this.isAllChecked) {
                this.selectRecords = this.imgListData.length
                for (let i = 0; i < this.imgListData.length; i++) {
                    this.imgListData[i].aboolean = true
                }
            } else {
                this.selectRecords = 0
                for (let i = 0; i < this.imgListData.length; i++) {
                    this.imgListData[i].aboolean = false
                }
            }
        },
        // 右侧图片列表单选
        selectImg(value) {
            this.imgListData[value].aboolean = !this.imgListData[value].aboolean
            var isCheckAll = false
            for (let i = 0; i < this.imgListData.length; i++) {
                if (this.imgListData[i].aboolean === true) {
                    isCheckAll = true
                } else {
                    isCheckAll = false
                    break
                }
            }
            if (this.imgListData[value].aboolean === false) {
                this.isAllChecked = false
                this.selectRecords = this.selectRecords - 1
            } else {
                this.selectRecords = this.selectRecords + 1
                if (isCheckAll) {
                    this.isAllChecked = true
                } else {
                    this.isAllChecked = false
                }
            }
        },
        // 获取合集列表data
        getColListData() {
            this.setLoading(true)
            var params = {
                materialtype: 2
            }
            getColList({
                data: Object.assign({}, params),
                success: data => {
                    // console.log('图片合集列表data:', data)
                    this.imgCollection = data.data
                    this.setLoading(false)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取所有的图片信息
        getAllImage() {
            this.setLoading(true)
            var params = {
                catalogInnerId: ''
            }
            findAllImage({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.imgListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.leftMenuIsSelect = 0
                    if (this.pageParams.page === 1) {
                        this.imgCollection = data.data.cataloglist
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {},
    filters: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'permission'
        ])
    },
    components: {}
}
</script>

<style lang="scss" scoped type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .image {
        display: flex;
        .left_menu_box{
            width: 150px;
            min-height: 500px;
            margin-right: 20px;
            border-right: 1px solid #DCDFE6;
            box-sizing: border-box;
            &>div{
                text-align: center;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: 150px;
                font-size:14px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                color:rgba(48,49,51,1);
                box-sizing: border-box;
            }
            &>div:hover{
                background:rgba(230,241,252,1);
            }
            .top_box{
                // background:rgba(230,241,252,1);
                border-right: 4px solid transparent;
                text-align: right;
                padding-right: 36px;
                cursor: pointer;
            }
            .img_list{
                border-right: 4px solid transparent;
                padding-right: 15px;
                .el-dropdown-link {
                    cursor: pointer;
                }
                .el-icon--right {
                    margin-left: 10px;
                }
                .el-dialog__header{
                    display: flex;
                    justify-content: space-between;
                }
                .el-dropdown {
                    display: flex;
                    line-height: 1;
                    span{
                        display: inline-block;
                        width: 74px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                }
            }
            .is_select{
                background:rgba(230,241,252,1);
                border-right: 4px solid #409EFF;
                color:rgba(64,158,255,1);
                .el-dropdown-link{
                    color:rgba(64,158,255,1);
                }
            }
        }
        .right_main_box{
            width: 100%;
            min-width: 500px;
            min-height: 500px;
            .img_content_list{
                .no_content{
                    background-image: url('../../../common/images/other/zwsj@2x.png');
                    background-size:372px 269px !important;
                    background-position:top center !important;
                    background-repeat: no-repeat;
                    height: 500px;
                    // margin-top: 30px;
                    color:rgba(144,147,153,1);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .img_content_box{
                    .select_box{
                        // background-color: rgb(185, 156, 156);
                        color: #606266;
                        display: flex;
                        &>div:nth-of-type(1){
                            .el-checkbox {
                            margin-right: 12px;
                        }
                            &>span{
                                margin-right: 40px;
                            }
                        }
                        &>div:nth-of-type(2){
                            display: flex;
                            align-items: center;
                            &>span{
                                color: #409EFF;
                                margin-right: 12px;
                            }
                            &>span:hover{
                                color: rgb(12, 130, 248);
                                cursor: pointer;
                            }
                        }
                    }
                    .imgs_box{
                        margin-top: 20px;
                        // min-height: 560px;
                        display: flex;
                        flex-wrap: wrap;
                        .img_item{
                            width: 120px;
                            margin-right: 20px;
                            margin-bottom: 20px;
                            &>div:nth-of-type(1){
                                width: 120px;
                                height: 120px;
                                position: relative;
                                img:nth-of-type(1){
                                    width: 120px;
                                    height: 120px;
                                }
                                p{
                                    width: 24px;
                                    height: 24px;
                                    position: absolute;
                                    top: 10px;
                                    left: 10px;
                                    display: none;
                                    cursor: pointer;
                                    background-image: url('../../../common/images/other/Shape@2x.png');
                                    background-size:24px 24px !important;
                                }
                                .show{
                                    display: block!important;
                                    background-image: url('../../../common/images/other/Shape2@2x.png');
                                }
                            }
                            &>div:nth-of-type(1):hover{
                                p{
                                    display: block;
                                }
                            }
                            &>div:nth-of-type(2){
                                color: #606266;
                                margin: 8px 0;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                text-align: center;
                                line-height: 20px;
                            }
                        }
                    }
                    .page {
                        @include flexBox(center)
                    }
                }
            }
        }
    }
</style>
